const modalSupportTypo = {
  isNewDataTrue: 'Registrar nuevo archivo de soporte',
  isNewDataFalse: 'Editar archivo de soporte'
};

export default modalSupportTypo;
